export default function Promotions() {
  const scrollToPromotions = () => {
    const promotionsSection = document.getElementById('promocoes');
    if (promotionsSection) {
      promotionsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="promocoes" className="py-16 md:py-32 px-6 md:px-20 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-8 md:mb-12 md:mx-10">
          <div 
            className="rounded-2xl md:rounded-3xl overflow-hidden"
            style={{ height: '250px' }}
          >
            <img 
              src="https://public.readdy.ai/ai/img_res/63eb68bb0c87c24c9753ff3a9b6e4928.jpg"
              alt="Promoção"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="text-center mb-8 md:mb-12 px-4">
          <p className="text-2xl md:text-4xl leading-relaxed" style={{ lineHeight: '1.5' }}>
            <span className="italic text-gray-400 font-light">Desconto especial</span>{' '}
            <span className="font-bold text-gray-900">na segunda armação</span>{' '}
            <span className="italic text-gray-400 font-light">com até</span>{' '}
            <span className="font-bold text-gray-900">50% OFF</span>
          </p>
        </div>

        <div className="flex justify-center">
          <button 
            onClick={scrollToPromotions}
            className="bg-gray-900 hover:bg-gray-800 text-white px-8 md:px-12 py-3 md:py-4 rounded-full text-sm md:text-base font-medium transition-all cursor-pointer whitespace-nowrap"
          >
            Ver Promoções
          </button>
        </div>
      </div>
    </section>
  );
}